module.exports = new __parcel__URL__("mrnaNewsIcon.096a95d9.png").toString();